// extracted by mini-css-extract-plugin
module.exports = {"ratingWrp":"slider_ratingWrp__3ZDtO","ratingTextWrp":"slider_ratingTextWrp__2BlLs","ratingLabel":"slider_ratingLabel__1VvW8"};